const colors = {
  // brand / primary
  primary: '#2563EB', // WCAG AA compliant - 4.52:1 contrast ratio
  primaryHover: '#1F5CD6', // or #0A3DA4
  primaryOn: '#FAFAFA',

  // text
  text: '#080910',
  textMuted: '#989FA6',
  textLight: '#FAFAFA',

  // neutrals / backgrounds / borders
  white: '#FFFFFF',
  neutral50: '#FAFAFA',
  neutral100: '#F9FAFB',
  neutral200: '#F0F0F0',
  neutral300: '#DEDEDE',
  neutral400: '#E6E6E6',

  // states - WCAG AA compliant colors (4.5:1+ contrast on white)
  danger: '#C53030', // WCAG AA compliant - 4.76:1 contrast ratio
  dangerHover: '#A32828',
  success: '#15803D', // WCAG AA compliant - 4.59:1 contrast ratio
  successHover: '#166534',

  // others (from index.css and templates)
  footerTop: '#081331',
  footerBottom: '#131722'
} as const

export default colors
export type Colors = typeof colors
